var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCialFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 50,
    viewBox: "0 0 62 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_871_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2308 42.3077V38.4616V30.7692H15.3847V38.4616H11.5385V11.549H15.3847V19.2308H19.2308V7.70287V7.69232H7.69238V7.70287V42.3077V42.3147L19.2308 42.3077Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2305 23.0805V26.9266H23.0766V42.3147H26.9228V26.9266H30.7689V42.3147H34.6151V26.9266H38.4612V42.3077H42.3074V26.9231H38.4612V23.0805H34.6151V11.5385H38.4612V23.0769H42.3074V11.5385V7.69232H38.4612H34.6151H30.7689V11.5385V23.0805H26.9228V7.69232H23.0766V23.0805H19.2305Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0005 42.3077H53.8466V38.4616H50.0005V7.69232H46.1543V42.3077V42.3147H50.0005V42.3077Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6923 0H0V50H61.5385V0H57.6923ZM57.6923 46.1538H3.84615V3.84615H57.6923V46.1538Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_871_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.5385,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCialFooterLogo);
export default __webpack_public_path__ + "static/media/cial-footer-logo.3d74f18d774cf23b12d07efee322261a.svg";
export { ForwardRef as ReactComponent };